<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Hiba részletei</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<div class="row">
				<div class="col">
					<h4>Bizonylat</h4>
					<table class="table table-sm table-dark">
						<tbody>
							<tr>
								<td style="width:140px;">Bizonylat UUID</td>
								<td><%- receipt.uuid %></td>
							</tr>
							<tr>
								<td>Rendelés UUID</td>
								<td><%- receipt.order_uuid %></td>
							</tr>
							<tr>
								<td>Időpont</td>
								<td><%- Anvil.moment(receipt.receipt_dt).format("YYYY. MM. DD. HH:mm:ss") %></td>
							</tr>
							<tr>
								<td>Állapot</td>
								<td><%- receipt.state %></td>
							</tr>
						</tbody>
					</table>

					<h4>Hibaüzenetek</h4>
					<% for (const message of receipt.state_message) { %>
						<div class="alert alert-info p-2 mb-1">
							<table class="table table-sm table-info mb-0">
								<tbody>
									<tr>
										<td style="width: 120px;">Hibakulcs</td>
										<td><strong><%- message.hibaKulcs %></strong></td>
									</tr>
									<tr>
										<td>Hibaüzenet</td>
										<td class="text-warning"><%- message.hibaUzenet %></td>
									</tr>
									<tr>
										<td>Mező</td>
										<td><small><%- message.mezoNeve %></small></td>
									</tr>
									<tr>
										<td>Küldött érték</td>
										<td><small><%- message.kuldottErtek || '<span class="text-secondary">[üres]</span>' %></small></td>
									</tr>
								</tbody>
							</table>
						</div>
					<% } %>
				</div>
				<div class="col">
					<h4>Jelentés (újra előállítva)</h4>
					<pre class="form-control" style="height:calc(100vh - 300px); overflow-y:scroll;" readonly><%- JSON.stringify(order_report, undefined, 4).replaceAll('\n', '<br />').replace('"rendelesVegosszegeHUF": "0.00",', '<span class="text-warning">"rendelesVegosszegeHUF": "0.00",</span>') %></pre>
				</div>
			</div>
		</div>
		<div class="modal-footer text-end">
			<button type="button" class="btn btn-danger float-end" onclick="Anvil.page.modal.manual_fix()"><i class="fa fa-wrench me-2"></i>Kézi javítás bejegyzése</button>
			<button type="button" class="btn btn-warning float-end" onclick="Anvil.page.modal.resend()"><i class="fa fa-redo-alt me-2"></i>Újraküldés</button>
		</div>
	</div>
</div>

<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async manual_fix () {
		await Anvil.exec('c_order/error_log/action_manual_fix_ntak_order_summary', Anvil.page.modal.db_name, Anvil.page.modal.receipt.uuid)
	},

	async resend () {
		await Anvil.exec('c_order/error_log/action_resend_ntak_order_summary', Anvil.page.modal.db_name, Anvil.page.modal.receipt.uuid)
	}
})
</script>